import { Component, OnInit } from '@angular/core';
import { ScwsService } from '../../services/scws-service.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { IdopteCheckerMessages } from '../../../shared/models/component-messages/idopte-checker-messages';
import { LogService } from 'src/app/modules/shared/services/log.service';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../../shared/services/common.service';
import { DeviceEnum } from '../../../shared/models/device-enum';

@Component({
  selector: 'app-idopte-checker',
  templateUrl: './idopte-checker.component.html',
  styleUrls: ['./idopte-checker.component.scss']
})
export class IdopteCheckerComponent implements OnInit {

  public os: string;
  public idopteCheckerMessages = new IdopteCheckerMessages();
  public deviceInfo;
  public isPresent = false;
  public isNotUpToDate = false;
  public deviceEnum: typeof DeviceEnum = DeviceEnum;

  constructor(private scwsService: ScwsService, private LOG: LogService,
    private deviceService: DeviceDetectorService, private commonService: CommonService) {
  }

  public ngOnInit() {
    this.deviceInfo = this.deviceService.getDeviceInfo();
    this.LOG.info('IDOPTE CHECKER : {0}', this.deviceInfo.os);
    this.scwsService.connectSCWS().subscribe((value) => {
      value.subscribe(async () => {
        await this.scwsService.createEnvironment();
        sessionStorage.setItem(environment.scwsEnv, JSON.stringify(this.scwsService.saveEnvironment()));
        this.scwsService.restoreEnvironment(sessionStorage.getItem(environment.scwsEnv))
          .subscribe(() => this.LOG.log('Environment is restored. '), error => {
            console.error('Environment can\'t restored : ', error);
          });
        this.scwsService.getIdopteVersion().subscribe((v: any) => {
          this.checkVersion(v.version);
        });
        this.isPresent = true;
      });
    }, () => {
      this.isPresent = false;
    });
  }

  private checkVersion(value) {
    const result = this.commonService.versionCompare(environment.idopteVersion, value, { zeroExtend: true });
    if (isNaN(result)) {
      this.LOG.error('Syntax of idopte version is not valid. (ex : 1.0.0.0)');
    }

    switch (result) {
      case 1:
        this.LOG.log('Idopte version is not a latest');
        this.isNotUpToDate = true;
        break;
      case 0:
        this.LOG.log('Idopte version is latest');
        break;
      case -1:
        this.LOG.log('Idopte version is superior to the latest');
        break;
      default:
        const version = isNaN(result) ? 'NaN' : 'Can\'t get idopte version ';
        this.LOG.error('Trying to get version of Idopte : -- ' + version + ' -- | idopte version is maybe inferior of 6.21.0.0');
    }
  }
}
